import state from "@/store/modules/order-service/state";
import actions from "@/store/modules/order-service/actions";
import mutations from "@/store/modules/order-service/mutations";
import getters from "@/store/modules/order-service/getters";

export default {
  state,
  actions,
  mutations,
  getters
}